module.exports = __webpack_public_path__ + "img/calculator.7939e9f5.jpg";